module.exports = __webpack_public_path__ + "img/egg_hammer.16d4887e.png";